module.exports = __webpack_public_path__ + "img/0ea644a.jpg";